import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-archiveConfig",
  "use": "icon-archiveConfig-usage",
  "viewBox": "0 0 1028 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1028 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-archiveConfig\"><path d=\"M548.416284 434.631111c85.902222-55.068444 126.122667-162.816 98.588445-263.850667C619.527396 69.745778 530.894507 0 429.973618 0 329.109618 0 240.476729 69.745778 212.942507 170.780444c-27.534222 101.034667 12.743111 208.782222 98.645333 263.907556C107.072284 494.648889 3.250062 636.017778 0.064284 858.851556A56.888889 56.888889 0 0 0 56.896284 916.650667h502.727112c-54.044444-74.296889-76.288-156.046222-66.958223-245.304889 14.791111-123.335111 105.870222-188.302222 154.908445-197.973334-22.528-13.312-58.481778-27.306667-99.100445-38.684444zM954.090951 550.513778a238.819556 238.819556 0 0 0-337.578667 337.692444 238.819556 238.819556 0 1 0 337.578667-337.692444z m-44.259555 293.546666a176.469333 176.469333 0 1 1-249.742223-249.400888 176.469333 176.469333 0 0 1 249.742223 249.344z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/archiveConfig.svg
// module id = g4hV
// module chunks = 78